import styled from "styled-components";

export const BestSellersListStyle = styled.div`
  margin-top: 3rem;
  margin-left: 2rem;
  margin-right: 2rem;

  @media (max-width: 400px) {
    margin: 0;

    h1 {
      font-size: 1.4rem;
      text-align: center;
    }
  }
`;
